/* @flow */
import * as React from 'react';
import { observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import Typography from '@material-ui/core/Typography';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import List from '@material-ui/core/List';

import styles from './ChartTable.module.scss';

type TypeProps = {|
  children: Array<*>,
  onClick: Function,
|} & TranslatorProps;

@translate()
@observer
export default class ChartTable extends React.Component<*> {
  /*eslint max-len: ["error", { "ignoreStrings": true }]*/

  render(): React.Element<*> {
    const { children, onClick }: TypeProps = this.props;

    return (
      <ExpansionPanel
        className={`${styles['chart-table']} ${styles[this.props.expanded ? 'open' : null]} ${
          styles[children ? 'hasChildren' : 'empty']
        }`}
        expanded={this.props.expanded}
      >
        <div className={styles['chart-table-color']} style={{ background: this.props.color }} />
        <ExpansionPanelSummary className={styles['chart-table-header']} onClick={onClick}>
          <Typography className={styles['chart-table-title']}>{this.props.title}</Typography>
          <Typography className={styles['chart-table-number']}>{this.props.number}</Typography>
          {children && (
            <div className={styles['chart-table-icon']}>
              <svg>
                <use xlinkHref={`#icon-chevron-${this.props.expanded ? 'down' : 'up'}`} />
              </svg>
            </div>
          )}
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={styles['chart-table-container']}>
          <List className={styles['chart-table-list']} disablePadding={true}>
            {children}
          </List>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    );
  }
}
